import React from 'react';
import EngineResetCacheWidget from './EngineResetCacheWidget';
import EngineReloadAuctionWidget from './EngineReloadAuctionWidget';
import EngineResetAuctionWidget from './EngineResetAuctionWidget';
import EngineResetLaneWidget from './EngineResetLaneWidget';
import EngineReloadScreensWidget from './EngineReloadScreensWidget';
import { Header, Divider, Segment } from 'semantic-ui-react';
import { CardLayout } from '../Styles';

export const Section = () => {
  return (
    <Segment basic>
      <Header as="h2">Engine</Header>
      <Divider clearing />
      <CardLayout>
        <EngineResetCacheWidget />
        <EngineReloadAuctionWidget />
        <EngineResetAuctionWidget />
        <EngineResetLaneWidget />
        <EngineReloadScreensWidget />
      </CardLayout>
    </Segment>
  );
};

export default Section;
